export const FETCH_BATCH_PROCESSES_REQUEST = 'FETCH_BATCH_PROCESSES_REQUEST';
export const FETCH_BATCH_PROCESSES_SUCCESS = 'FETCH_BATCH_PROCESSES_SUCCESS';
export const FETCH_BATCH_PROCESSES_FAILURE = 'FETCH_BATCH_PROCESSES_FAILURE';

export const DELETE_BATCH_PROCESS_REQUEST = 'DELETE_BATCH_PROCESS_REQUEST';
export const DELETE_BATCH_PROCESS_SUCCESS = 'DELETE_BATCH_PROCESS_SUCCESS';
export const DELETE_BATCH_PROCESS_FAILURE = 'DELETE_BATCH_PROCESS_FAILURE'; 